// extracted by mini-css-extract-plugin
export default {"root":"U5OZxt_QayrsGhxfS2Af","iconLetter":"ccT2TX40fxkqk8iL3438","placeHolderShimmer":"xmwPaAu7Ylb5sNEySFG1"};